export default __webpack_public_path__ + "static/media/get-it-in-google-play.d0af2ff0.png";